function confirmClear() {
	return {
		restrict: "A",
		priority: 100,
		link(scope, element, attrs) {
			let pending = false;
			let pendingKey;
			let pendingDisabled;
			let timer;
			const clearLabel = attrs.confirmClearLabel || attrs.ariaLabel || attrs.uibTooltip || "Clear";
			const getConfirmationState = () => ({
				key: scope.$eval(attrs.confirmClearKey),
				disabled: scope.$eval(attrs.confirmClearDisabled)
			});
			const isConfirmationStale = state =>
				state.key !== pendingKey || state.disabled !== pendingDisabled;

			const reset = () => {
				pending = false;
				pendingKey = undefined;
				pendingDisabled = undefined;
				if(timer) {
					clearTimeout(timer);
					timer = undefined;
				}
				attrs.$set("uibTooltip", clearLabel);
				attrs.$set("ariaLabel", clearLabel);
				element.removeClass("confirm-clear-pending");
			};

			element.on("click", event => {
				event.preventDefault();
				event.stopImmediatePropagation();

				const currentState = getConfirmationState();
				if(pending && isConfirmationStale(currentState)) {
					reset();
				}

				if(pending) {
					reset();
					scope.$evalAsync(attrs.confirmClear);
					return;
				}

				pending = true;
				pendingKey = currentState.key;
				pendingDisabled = currentState.disabled;
				attrs.$set("uibTooltip", "Confirm clear");
				attrs.$set("ariaLabel", "Confirm clear");
				element.addClass("confirm-clear-pending");
				timer = setTimeout(() => {
					scope.$evalAsync(reset);
				}, 4000);
			});

			scope.$watchGroup([attrs.confirmClearKey, attrs.confirmClearDisabled], values => {
				if(pending && isConfirmationStale({ key: values[0], disabled: values[1] })) {
					reset();
				}
			});

			scope.$on("$destroy", () => {
				reset();
				element.off("click");
			});
		}
	};
}

export default angular
	.module("vesl.behaviors.confirm-clear", [])
	.directive("confirmClear", confirmClear).name;